import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import AppShell from './AppShell'
import LoginScreen from './auth/LoginScreen'
import {
  AUTH_AUTHENTICATED,
  AUTH_LOADING,
  useAuth
} from '../auth/AuthContext'

export default function AuthBoundary () {
  const { status } = useAuth()

  if (status === AUTH_LOADING) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center'
        }}
      >
        <CircularProgress aria-label="Loading session" />
      </Box>
    )
  }

  if (status === AUTH_AUTHENTICATED) {
    return <AppShell />
  }

  return <LoginScreen />
}
